import { useParams } from "react-router-dom";
import { Mui } from "@osu/react-ui";
import { useSelector } from "react-redux";
import {
  selectCurrentFormDataStatus,
} from "../../../services/form/slices";
import {
  FORM_STATUS_COLORS,
  FORM_STATUS_LABELS,
  FORM_STATUSES,
} from "../../../util/constants";
import useReadOnlyMode from "../../hooks/useReadOnlyMode";
import { selectIsAdmin } from "../../../services/authorization/slices";

export const colorize = (theme, status, color) => {
  const statusColor = FORM_STATUS_COLORS[status];
  const hex = theme.palette.colors?.[color || statusColor];
  const lightMode = theme.palette.mode === "light";
  if (hex) {
    const textColorFn = lightMode ? Mui.darken : Mui.lighten;
    const backgroundColorFn = lightMode ? Mui.lighten : Mui.darken;
    return {
      borderColor: hex,
      backgroundColor: backgroundColorFn(hex, .9),
      color: textColorFn(hex, 0.6),
      borderWidth: "3px",
    };
  }
};

function SummaryInfo() {
  const { id, type } = useParams();
  const { readOnly, toggleReadOnly } = useReadOnlyMode()
    const isAdmin = useSelector(selectIsAdmin);
  const status = useSelector((state) => {
    return selectCurrentFormDataStatus(state, type, id);
  });

  return (
    <Mui.Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 2,
    }}>
      <Mui.Chip
        component="span"
        label={FORM_STATUS_LABELS[status] || status || FORM_STATUS_LABELS[FORM_STATUSES.UNSAVED]}
        size="lg"
        variant="outlined"
        sx={[(theme) => colorize(theme, status), { fontWeight: "bold" }]}
      />
      {isAdmin && <Mui.FormControlLabel 
        label="Read Only" 
        control={
          <Mui.Switch 
          checked={readOnly}
          onChange={event => toggleReadOnly(event.target.checked)}
      />} />}
    </Mui.Box>
  );
}

export default SummaryInfo;
